import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-forma-pago',
  templateUrl: './forma-pago.component.html',
  styleUrls: ['./forma-pago.component.scss']
})
export class FormaPagoComponent implements OnInit {
  public formasPago;
  public reqfpg;
  public csc;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private serviciosService: ServiciosService) { }

  ngOnInit() {
    this.serviciosService.formasDePago().subscribe(formas => {
      this.formasPago = formas;
      console.log(this.formasPago);
    })

    this.reqfpg = this.datos.fpg;
    this.csc = this.datos.csc;

  }

  enviarfpg(){
    console.log(this.reqfpg, this.csc);
    this.serviciosService.putFormasdePago(this.csc, this.reqfpg).subscribe((result)=>{
      console.log(result);
      
    })
  }

}
